import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import BasicFilterDropdown from '../BasicFilterDropdown/BasicFilterDropdown';
import BasicDropdownOption from '../BasicDropdownOption/BasicDropdownOption';
import { useWindowSize } from '../../../../../../utils/hooks';
import classes from './DatePostedFilter.module.scss';
import { jobFilters, responsiveSizeJobs, responsiveSizeTimesheet } from '../../../../../../utils/constants';
import MainButton from '../../../../buttons/MainButton';
import { buttonVariants } from '../../../../buttons/types';
import colors from '../../../../../../scss/colors';

export default function DatePostedFilter({
  dateposted,
  selected,
  changeDatePosted,
  values,
  count,
  pendingCount,
  footerHandler
}) {
  const { t } = useTranslation();
  const { width } = useWindowSize();

  const [open, setOpen] = useState(false);
  const [dateLabel, setDateLabel] = useState(t('common.filters.dateposted'));

  const selectedLabel = dateposted.find((item) => item?.value === parseInt(selected, 10));

  return (
    <BasicFilterDropdown
      type={jobFilters.DATE_POSTED}
      text={selectedLabel?.label || dateLabel || t('common.filters.dateposted')}
      active={selected}
      open={open}
      setOpen={setOpen}
      sxBox={{
        padding: '39px 0px 33px 0px',
        maxHeight: '650px',
        maxWidth: '400px'
      }}
      filterCount={count}
      pendingCount={pendingCount}
      showHandler={footerHandler}
      isCountVisible
    >
      <div className={classes.container}>
        <BasicDropdownOption
          key={t('common.filters.anytime')}
          text={t('common.filters.anytime')}
          selected={!selected}
          clickHandler={() => {
            changeDatePosted({ ...values, date: '' });
            setDateLabel(t('common.filters.dateposted'));
          }}
        />
        <div className={classes.listContainer}>
          {dateposted.map(({ label, value }) => (
            <BasicDropdownOption
              key={label}
              text={label || t('common.filters.anytime')}
              selected={JSON.stringify(selected) === JSON.stringify(value.toString())}
              clickHandler={() => {
                changeDatePosted({ ...values, date: value.toString() });
                setDateLabel(label);
              }}
            />
          ))}
        </div>
        {width > responsiveSizeJobs && (
          <div className={classes.footerContainer}>
            <MainButton
              variant={buttonVariants.TEXT}
              size="small"
              action={() =>
                selected?.length
                  ? (setDateLabel(t('common.filters.dateposted')), changeDatePosted({ ...values, date: '' }))
                  : setOpen(false)
              }
            >
              {selected ? t('common.filters.reset') : t('common.general.cancel')}
            </MainButton>
            <MainButton
              forceWidth="129px"
              rounded
              size="small"
              sx={{
                fontSize: '13px'
              }}
              action={() => {
                footerHandler();
                setOpen(false);
              }}
            >
              {pendingCount ? (
                <CircularProgress sx={{ color: colors.WHITE }} size="20px" />
              ) : (
                `Show ${count || 0} results`
              )}
            </MainButton>
          </div>
        )}
      </div>
    </BasicFilterDropdown>
  );
}
